var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarBorderOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "various",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_784",
    "data-name": "Trac\\xE9 784",
    d: "M7.24,11.389,3.921,8.509,8.3,8.13,10,4.1,11.71,8.14l4.38.38L12.77,11.4l1,4.28L10,13.4,6.24,15.67ZM10,0,7.19,6.63,0,7.24l5.46,4.73L3.82,19,10,15.27,16.18,19l-1.63-7.03L20,7.24l-7.19-.621Z",
    transform: "translate(2 2)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBorderOutlined);
export default __webpack_public_path__ + "static/media/StarBorderOutlined.11eaf2cee468efb0ff3f7e1379314091.svg";
export { ForwardRef as ReactComponent };